import { render, staticRenderFns } from "./fileInfo.vue?vue&type=template&id=417d12a4"
import script from "./fileInfo.vue?vue&type=script&lang=js"
export * from "./fileInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports